import React from "react"
import { motion } from "framer-motion"
import { Menu } from "lucide-react"
import { useNavigate } from "react-router-dom"

import UserProfileDropdown from "@components/layout/UserProfileDropdown"
import NotificationPreview from "@components/layout/NotificationPreview"
import { ThemeToggle } from "@components/ui"
import { useUIStore } from "@store"
import { ReactComponent as LogoLarge } from "@assets/V2/t4ever-logo-large.svg"

interface Props {
  isMobile: boolean
}

const Header: React.FC<Props> = ({ isMobile }) => {
  const {
    toggleSidebar,
    notifications,
    sidebarCollapsed,
    markNotificationAsRead,
    markAllNotificationsAsRead,
    removeNotification,
  } = useUIStore()
  const navigate = useNavigate()

  const handleViewAllNotifications = () => {
    navigate("/notifications")
  }

  return (
    <>
      <motion.header className="bg-white dark:bg-slate-900 shadow-sm border-b border-legacy-light/20 dark:border-legacy-light/10 px-4 py-3 lg:px-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <button
              onClick={toggleSidebar}
              className="p-2 rounded-lg hover:bg-legacy-light/20 dark:hover:bg-legacy-light/10 transition-colors duration-200 lg:hidden"
            >
              <Menu className="h-5 w-5 text-legacy-dark dark:text-legacy-cream" />
            </button>
            {sidebarCollapsed && !isMobile && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="!ml-0"
              >
                <LogoLarge className="h-7 w-auto" />
              </motion.div>
            )}
          </div>
          <div className="flex items-center space-x-2">
            <ThemeToggle />
            <NotificationPreview
              notifications={notifications}
              onMarkAsRead={markNotificationAsRead}
              onMarkAllAsRead={markAllNotificationsAsRead}
              onDelete={removeNotification}
              onViewAll={handleViewAllNotifications}
            />
            <UserProfileDropdown />
          </div>
        </div>
      </motion.header>
    </>
  )
}

export default Header
